export enum BannerEnum {
  bookMeeting = "bookMeetingBanner",
  paymentFailed = "paymentFailedBanner",
  channelConnection = "channelConnectionBanner",
  inviteUserAutomation = "inviteUserAutomationBanner",
  balanceWarning = "balanceWarningBanner",
}
